import { Input, Typography } from '@breetometer/components';
import { FiatIcon, SearchIcon } from 'BreetAssets';
import { CURRENCYCONFIG, type ICurrencyDropDownItem } from 'BreetHelpers';
import { type ChangeEvent, type MouseEvent, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';

import type { CurrencyDropDownItemProps } from '../../Dropdown.helpers';
import CurrencyItemOptions from '../item-options/Currency';

export const CurrencyDropdownItems = ({
	handleItemSelect,
	dropDownRef,
	selectedItem,
	items,
	placeholder,
	dropdownStyles,
	handleVisibility,
	hideSearch,
	CustomItemOption,
}: CurrencyDropDownItemProps) => {
	const [searchTerm, setSearchTerm] = useState('');

	const handleSearchTerm = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	}, []);

	const handleItemSelection = useCallback(
		(item: ICurrencyDropDownItem) => {
			const handler = handleItemSelect?.(item);

			return (e: MouseEvent<HTMLButtonElement>) => {
				setSearchTerm('');
				handler?.(e);
				handleVisibility();
			};
		},
		[handleItemSelect, handleVisibility]
	);

	const handleSearchFilter = useCallback(
		(item: ICurrencyDropDownItem) => {
			const serchItem = searchTerm.toLowerCase();

			return item.currency.toLowerCase().includes(serchItem);
		},
		[searchTerm]
	);

	const filteredItems = items.filter(handleSearchFilter);

	return createPortal(
		<div
			className='dropdown_content_item bg-primary-500 border-tertiary-400'
			ref={dropDownRef}
			style={dropdownStyles}
			data-modal-ignore='true'
		>
			{!hideSearch && (
				<>
					{selectedItem?.currency && (
						<div className='dropdown_content_item_label'>
							<Typography
								as='label'
								variant='sub_head'
							>
								<FiatIcon
									currencyCode={selectedItem.currency}
									variant='round'
								/>
								{CURRENCYCONFIG[selectedItem.currency].symbol}
								{selectedItem.walletBalance}
							</Typography>
						</div>
					)}
					<div className='dropdown_content_item_search'>
						<SearchIcon className='dropdown_content_item_search_icon' />
						<Input
							type='text'
							label=''
							id=''
							value={searchTerm}
							onChange={handleSearchTerm}
							className='dropdown_content_item_search_input'
							widthType='full'
							placeholder={placeholder}
							data-modal-ignore='true'
						/>
					</div>
				</>
			)}

			<div className='dropdown_content_item_options'>
				<div className='dropdown_content_item_options_container scrollbar'>
					<CurrencyItemOptions
						items={filteredItems}
						handleItemSelection={handleItemSelection}
						CustomItemOption={CustomItemOption}
					/>
					{filteredItems.length === 0 && (
						<div className='dropdown_content_item_options_item_no_country'>
							<Typography
								as='p'
								variant='sub_head'
							>
								No data found
							</Typography>
						</div>
					)}
				</div>
			</div>
		</div>,
		document.body
	);
};
